import { Controller } from "@hotwired/stimulus"
import { createLogger } from "../lib/logger"
import { createI18nGetter } from "../lib/i18n_helper"
import { showToast } from "../lib/platform_toast"

// Address Copy Controller - Clipboard integration with Toast notification
// I18n support via data-i18n-* attributes
// Connects to data-controller="address-copy"
const log = createLogger('AddressCopy')

export default class extends Controller {
  static values = {
    address: String
  }

  connect() {
    log.debug('connect')
    this.i18n = createI18nGetter(this)
  }

  // Copy address to clipboard and show Toast notification
  async copy(event) {
    event.preventDefault()

    if (!this.addressValue) {
      log.error('No address value provided')
      return
    }

    try {
      // Modern Clipboard API (Chrome 63+, Safari 13.1+, Firefox 53+)
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(this.addressValue)

        // Success Toast
        this._dispatchToastEvent(
          this.i18n('CopySuccess', '地址已複製到剪貼簿'),
          "success"
        )
      } else {
        // Fallback: execCommand (deprecated but widely supported)
        const textarea = document.createElement('textarea')
        textarea.value = this.addressValue
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()

        const successful = document.execCommand('copy')
        document.body.removeChild(textarea)

        if (successful) {
          this._dispatchToastEvent(
            this.i18n('CopySuccess', '地址已複製到剪貼簿'),
            "success"
          )
        } else {
          throw new Error("execCommand failed")
        }
      }
    } catch (error) {
      log.error('Copy failed', error)

      // Error Toast
      this._dispatchToastEvent(
        this.i18n('CopyError', '複製失敗，請手動複製'),
        "error"
      )
    }
  }

  _dispatchToastEvent(message, variant = "info") {
    showToast(message, variant)
  }
}
